import { Layout } from 'antd';
import { Content } from 'antd/es/layout/layout';
import { FC } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar, Header } from 'widgets';
import style from './index.module.scss';

export const PrivateLayout: FC = () => {
  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Header />
      <Layout style={{ height: 'calc(100vh - 64px)', overflow: 'hidden' }}>
        <Sidebar />
        <Content className={style.content}>
          <Outlet />
        </Content>
      </Layout>
      {/* <Footer /> */}
    </Layout>
  );
};
